import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getrefest, getReporteope, getrefid } from "../../../redux/actions";
import * as XLSX from "xlsx";
import HashLoader from "react-spinners/HashLoader";
import {
    FaDatabase,
    FaCalendarAlt,
    FaSearch,
    FaFileExcel,
    FaInfoCircle,
    FaChartBar,
    FaArrowRight,
    FaExclamationTriangle
} from "react-icons/fa";
import styles from "./Reporteopera.module.css";

const Menuinformes = () => {
    const dispatch = useDispatch();
    const [referencia, setReferencia] = useState("");
    const [fechaIni, setFechaIni] = useState("");
    const [fechaFin, setFechaFin] = useState("");
    const [errorFecha, setErrorFecha] = useState("");
    const [loading, setLoading] = useState(false);
    const [mostrarTabla, setMostrarTabla] = useState(false);

    const refidData = useSelector((state) => state.refid);
    const estadorefe = useSelector((state) => state.estadoref);
    const reportes = useSelector((state) => state.reporte);

    useEffect(() => {
        dispatch(getrefest());
        setMostrarTabla(false);
    }, [dispatch]);

    useEffect(() => {
        if (fechaIni && fechaFin && fechaFin < fechaIni) {
            setErrorFecha("La fecha final no puede ser anterior a la inicial.");
        } else {
            setErrorFecha("");
        }
    }, [fechaIni, fechaFin]);

    const handleReferenciaChange = (e) => {
        const idSeleccionado = e.target.value;
        setReferencia(idSeleccionado);
        setMostrarTabla(false);

        if (idSeleccionado) {
            dispatch(getrefid(idSeleccionado));
        }
    };

    const handleFechaIniChange = (e) => {
        setFechaIni(e.target.value);
        setMostrarTabla(false);
    };

    const handleFechaFinChange = (e) => {
        setFechaFin(e.target.value);
        setMostrarTabla(false);
    };

    const handleGenerarReporte = async () => {
        if (!referencia || !fechaIni || !fechaFin || errorFecha) return;

        setLoading(true);
        await dispatch(
            getReporteope({
                Idref: referencia,
                fechaInicio: fechaIni,
                fechaFin: fechaFin,
            })
        );
        setLoading(false);
        setMostrarTabla(true);
    };

    const formatearFechaSimple = (fechaStr) => {
        if (!fechaStr) return "N/A";
        const fecha = new Date(fechaStr);
        if (isNaN(fecha.getTime())) return "N/A";
        const anio = fecha.getFullYear();
        const mes = String(fecha.getMonth() + 1).padStart(2, '0');
        const dia = String(fecha.getDate()).padStart(2, '0');
        return `${anio}-${mes}-${dia}`;
    };

    const handleExportExcel = () => {
        if (!refidData?.Registros || refidData.Registros.length === 0) {
            alert("No hay registros para exportar");
            return;
        }

        const wb = XLSX.utils.book_new();

        // --- 1. CREAR HOJA DE RESUMEN ---
        const resumenRows = [
            [`Reporte de Operaciones - Ref. ${reportes?.ref}`],
            [`Cliente: ${reportes?.Cliente}`],
            [`Período: ${fechaIni} a ${fechaFin}`],
            [],
            ["Puerto", "Material", "# Veh. (Período)", "Masa (t) (Período)", "Lote en curso", "Masa lote en curso (t)", "Acumulado material(t)"]
        ];

        reportes?.resumenCompleto?.forEach((item) => {
            const filtrado = reportes.resumenFiltrado?.find(f => f.Origen === item.Origen);
            const vehPeriodo = filtrado ? Number(filtrado["#Veh"]) || 0 : 0;
            const masaFiltradaValor = filtrado && !isNaN(Number(filtrado["Masafiltrada(t)"])) ? Number(filtrado["Masafiltrada(t)"]) : 0;

            const masaLoteEnCurso = refidData?.Registros?.filter(reg =>
                (reg.origen_material_nombre === item.Origen || reg.Origenmaterial === item.Origen) &&
                Number(reg.lote_num) === Number(item["Lote en curso"]) &&
                reg.Idestado !== 1
            ).reduce((acc, reg) => acc + Number(reg.pesoneto || 0), 0);

            const masaCompletaValor = !isNaN(Number(item["Masacompleta(t)"])) ? Number(item["Masacompleta(t)"]) : 0;

            resumenRows.push([
                item.Puerto,
                item.Origen,
                vehPeriodo,
                masaFiltradaValor,
                item["Lote en curso"],
                masaLoteEnCurso,
                masaCompletaValor
            ]);
        });

        resumenRows.push([]);
        resumenRows.push([
            "Subtotal - Período",
            "",
            subtotalVeh,
            subtotalMasa,
            "",
            "",
            ""
        ]);

        const acumuladoTotalValor = reportes?.resumenCompleto?.[0]?.["MasaTotal(t)"] || 0;
        resumenRows.push([
            "Acumulado total(t):",
            "",
            "",
            "",
            "",
            "",
            Number(acumuladoTotalValor)
        ]);

        const wsResumen = XLSX.utils.aoa_to_sheet(resumenRows);
        XLSX.utils.book_append_sheet(wb, wsResumen, "Resumen");

        // --- 2. CREAR HOJAS POR MATERIAL (Detalle de registros) ---
        const [y1, m1, d1] = fechaIni.split("-");
        const [y2, m2, d2] = fechaFin.split("-");
        const fechaInicioLimit = new Date(y1, m1 - 1, d1, 0, 0, 0);
        const fechaFinalLimit = new Date(y2, m2 - 1, d2, 23, 59, 59);

        const registrosFiltrados = refidData.Registros.filter((reg) => {
            if (reg.Idestado === 1 || !reg.fechacompleta) return false;
            const fechaRegistro = new Date(reg.fechacompleta);
            return fechaRegistro >= fechaInicioLimit && fechaRegistro <= fechaFinalLimit;
        });

        const registrosOrdenados = [...registrosFiltrados].sort((a, b) => {
            const loteA = Number(a.lote_num || 0);
            const loteB = Number(b.lote_num || 0);
            if (loteA !== loteB) return loteA - loteB;
            return new Date(a.fechacompleta) - new Date(b.fechacompleta);
        });

        if (registrosOrdenados.length > 0) {
            const datosDetalle = registrosOrdenados.map((reg) => ({
                Lote: reg.lote_num,
                Fecha: formatearFechaSimple(reg.fechacompleta),
                Hora: reg.fechacompleta ? new Date(reg.fechacompleta).toLocaleTimeString("es-ES", { hour: "2-digit", minute: "2-digit", hour12: false }) : "N/A",
                Placa: reg.placa || "N/A",
                "Masa(t)": reg.pesoneto ? Number(reg.pesoneto) : null,
                Material: reg.paral === 1 ? reg.origenparal || "N/A" : reg.origen_material_nombre || reg.Origenmaterial || "N/A",
                Referencia: reportes?.ref,
                Observaciones: reg.observaciones || "Ninguna",
            }));

            const materiales = [...new Set(datosDetalle.map((d) => d.Material))];
            materiales.forEach((material) => {
                const datosMaterial = datosDetalle.filter((d) => d.Material === material);
                const wsMaterial = XLSX.utils.json_to_sheet(datosMaterial, {
                    header: ["Lote", "Fecha", "Hora", "Placa", "Masa(t)", "Material", "Referencia", "Observaciones"],
                });
                const nombreHoja = material.replace(/[:\\/?*\[\]]/g, "-").substring(0, 31);
                XLSX.utils.book_append_sheet(wb, wsMaterial, nombreHoja);
            });
        }

        XLSX.writeFile(wb, `Reporte_Operaciones_Ref_${referencia}_${fechaIni}.xlsx`);
    };

    const subtotalVeh = reportes?.resumenFiltrado?.reduce((acc, item) => acc + (Number(item["#Veh"]) || 0), 0) || 0;
    const subtotalMasa = reportes?.resumenFiltrado?.reduce((acc, item) => acc + (Number(item["Masafiltrada(t)"]) || 0), 0) || 0;

    const mostrarBoton = referencia && fechaIni && fechaFin && !errorFecha;

    return (
        <div className={styles.container}>
            <div className={styles.headerSection}>
                <h1 className={styles.title}>Analítica de Operaciones</h1>
                <p className={styles.titleDescription}>
                    Genere informes detallados, estadísticas de pesaje y consolidados de material por rangos de fecha.
                </p>
            </div>

            <div className={styles.formContainer}>
                <div className={styles.formGroup}>
                    <label className={styles.label}>Referencia de Lote</label>
                    <div className={styles.inputWrapper}>
                        <FaDatabase className={styles.inputIcon} />
                        <select
                            className={`${styles.select} ${!referencia ? styles.error : ""}`}
                            value={referencia}
                            onChange={handleReferenciaChange}
                        >
                            <option value="">Seleccione una referencia...</option>
                            {estadorefe?.Registros?.map((registro) => (
                                <option key={registro.Idref} value={registro.Idref}>
                                    {registro.ref}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>

                <div className={styles.formGroup}>
                    <label className={styles.label}>Fecha de Inicio</label>
                    <div className={styles.inputWrapper}>
                        <FaCalendarAlt className={styles.inputIcon} />
                        <input
                            type="date"
                            className={`${styles.inputDate} ${!fechaIni ? styles.error : ""}`}
                            value={fechaIni}
                            onChange={handleFechaIniChange}
                        />
                    </div>
                </div>

                <div className={styles.formGroup}>
                    <label className={styles.label}>Fecha de Corte</label>
                    <div className={styles.inputWrapper}>
                        <FaCalendarAlt className={styles.inputIcon} />
                        <input
                            type="date"
                            className={`${styles.inputDate} ${!fechaFin || errorFecha ? styles.error : ""}`}
                            value={fechaFin}
                            onChange={handleFechaFinChange}
                        />
                    </div>
                </div>

                <div className={styles.buttonsRow}>
                    <button
                        className={styles.button}
                        onClick={handleGenerarReporte}
                        disabled={!mostrarBoton || loading}
                    >
                        <FaSearch /> Generar Análisis
                    </button>

                    {mostrarTabla && !loading && (
                        <button className={`${styles.button} ${styles.excelButton}`} onClick={handleExportExcel}>
                            <FaFileExcel /> Exportar Excel
                        </button>
                    )}
                </div>

                {errorFecha && (
                    <p className={styles.errorMessage}>
                        <FaExclamationTriangle /> {errorFecha}
                    </p>
                )}
            </div>

            {loading && (
                <div className={styles.spinnerContainer}>
                    <HashLoader color="#00c6ff" loading={loading} size={70} />
                    <p className={styles.loadingText}>Procesando base de datos...</p>
                </div>
            )}

            {!loading && mostrarTabla && reportes?.resumenCompleto?.length > 0 && (
                <div className={styles.tableWrapper}>
                    <div className={styles.tableHeader}>
                        <h2 className={styles.subtitle}>
                            <FaChartBar /> Ref. {reportes?.ref} — {reportes?.Cliente}
                        </h2>
                        <div className={styles.periodBadge}>
                            <FaCalendarAlt /> {fechaIni} <FaArrowRight style={{ fontSize: '10px' }} /> {fechaFin}
                        </div>
                    </div>

                    <div className={styles.tableContainer}>
                        <div className={styles.tableScroll}>
                            <table className={styles.table}>
                                <thead>
                                    <tr>
                                        <th rowSpan="2">Puerto de Operación</th>
                                        <th rowSpan="2">Material / Origen</th>
                                        <th colSpan="2" className={styles.periodHeader}>
                                            Ingresos en el Período Registrado
                                        </th>
                                        <th rowSpan="2">Lote Actual</th>
                                        <th rowSpan="2">Masa Lote (t)</th>
                                        <th rowSpan="2">Acumulado Total (t)</th>
                                    </tr>
                                    <tr>
                                        <th className={styles.periodHeader}># Vehículos</th>
                                        <th className={styles.periodHeader}>Masa (t)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {reportes.resumenCompleto.map((item, index) => {
                                        const filtrado = reportes.resumenFiltrado?.find(f => f.Origen === item.Origen);
                                        const vehPeriodo = filtrado ? Number(filtrado["#Veh"]) || 0 : 0;
                                        const masaFiltradaValor = filtrado && !isNaN(Number(filtrado["Masafiltrada(t)"]))
                                            ? Number(filtrado["Masafiltrada(t)"])
                                            : null;

                                        const masaLoteEnCurso = refidData?.Registros?.filter(reg =>
                                            (reg.origen_material_nombre === item.Origen || reg.Origenmaterial === item.Origen) &&
                                            Number(reg.lote_num) === Number(item["Lote en curso"]) &&
                                            reg.Idestado !== 1
                                        ).reduce((acc, reg) => acc + Number(reg.pesoneto || 0), 0);

                                        const masaCompletaValor = item["Masacompleta(t)"] !== undefined && !isNaN(Number(item["Masacompleta(t)"]))
                                            ? Number(item["Masacompleta(t)"])
                                            : null;

                                        return (
                                            <tr key={index}>
                                                <td style={{ fontWeight: '500' }}>{item.Puerto}</td>
                                                <td style={{ textAlign: "left", color: 'var(--secondary)', fontWeight: '600' }}>{item.Origen}</td>
                                                <td style={{ textAlign: "right", fontWeight: '700' }}>{vehPeriodo}</td>
                                                <td style={{ textAlign: "right" }}>
                                                    {masaFiltradaValor !== null
                                                        ? masaFiltradaValor.toLocaleString("es-ES", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                                                        : "-"}
                                                </td>
                                                <td style={{ textAlign: "center", fontWeight: '700' }}>
                                                    <span className={styles.badge}>{item["Lote en curso"]}</span>
                                                </td>
                                                <td style={{ textAlign: "right" }}>
                                                    {masaLoteEnCurso !== null
                                                        ? masaLoteEnCurso.toLocaleString("es-ES", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                                                        : "-"}
                                                </td>
                                                <td style={{ textAlign: "right", fontWeight: '800', color: 'white' }}>
                                                    {masaCompletaValor !== null
                                                        ? masaCompletaValor.toLocaleString("es-ES", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                                                        : "-"}
                                                </td>
                                            </tr>
                                        );
                                    })}
                                    <tr className={styles.subtotal}>
                                        <td colSpan="2">SUBTOTAL - PERÍODO SELECCIONADO</td>
                                        <td style={{ textAlign: "right" }}>{subtotalVeh}</td>
                                        <td style={{ textAlign: "right" }}>
                                            {subtotalMasa.toLocaleString("es-ES", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                        </td>
                                        <td colSpan="3"></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div className={styles.acumuladoBanner}>
                            <span className={styles.acumuladoText}>Masa Acumulada Total General</span>
                            <span className={styles.acumuladoValue}>
                                {reportes?.resumenCompleto?.[0]?.["MasaTotal(t)"] !== undefined
                                    ? Number(reportes.resumenCompleto[0]["MasaTotal(t)"]).toLocaleString("es-ES", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                                    : "-"}
                                <small style={{ fontSize: '1rem', marginLeft: '6px', color: 'var(--text-secondary)' }}>TON</small>
                            </span>
                        </div>
                    </div>

                    <div style={{ marginTop: '20px', display: 'flex', alignItems: 'center', gap: '8px', color: 'var(--text-secondary)', fontSize: '0.8rem' }}>
                        <FaInfoCircle />
                        Las cifras presentadas corresponden a los registros validados en el sistema para la referencia seleccionada.
                    </div>
                </div>
            )}
        </div>
    );
};

export default Menuinformes;
